/**
 * AOS (Animate On Scroll) Library
 */
import AOS from 'aos';

/**
 * Mobile Menu Toggle
 * Pure vanilla JavaScript - no dependencies
 */
(function() {
  'use strict';

  // Wait for DOM to be ready
  document.addEventListener('DOMContentLoaded', function() {

    // Initialize AOS
    AOS.init({
      duration: 500,
      easing: 'ease-out-cubic',
      once: true,
      offset: 50,
      delay: 50,
    });

    // Mobile menu toggle
    const burgerMenu = document.querySelector('.burger-menu');
    const mobileNav = document.querySelector('.mobile-nav');

    if (burgerMenu && mobileNav) {
      burgerMenu.addEventListener('click', function() {
        this.classList.toggle('burger-menu--opened');
        this.classList.toggle('burger-menu--closed');
        mobileNav.classList.toggle('active');
      });

      // Close mobile menu when clicking on a link
      const mobileNavLinks = mobileNav.querySelectorAll('a');
      mobileNavLinks.forEach(function(link) {
        link.addEventListener('click', function() {
          burgerMenu.classList.remove('burger-menu--opened');
          burgerMenu.classList.add('burger-menu--closed');
          mobileNav.classList.remove('active');
        });
      });

      // Close mobile menu on ESC key
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && mobileNav.classList.contains('active')) {
          burgerMenu.classList.remove('burger-menu--opened');
          burgerMenu.classList.add('burger-menu--closed');
          mobileNav.classList.remove('active');
        }
      });
    }

    // Header scroll effect
    const header = document.querySelector('.site-header');
    let lastScrollTop = 0;
    let scrollThreshold = 100; // Scroll pozícia v px, kedy sa aktivuje efekt

    if (header) {
      window.addEventListener('scroll', function() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop > scrollThreshold) {
          header.classList.add('scrolled');
        } else {
          header.classList.remove('scrolled');
        }

        lastScrollTop = scrollTop;
      });
    }

    // PDF Viewer responsive height
    function adjustPdfHeight() {
      const pdfContainers = document.querySelectorAll('.menu iframe, .menu embed, .menu object');

      if (pdfContainers.length > 0) {
        pdfContainers.forEach(function(pdf) {
          const containerWidth = pdf.parentElement.offsetWidth;
          // Optimálny multiplikátor pre zobrazenie PDF
          const calculatedHeight = containerWidth * 1.7;

          // Nastavíme minimálnu a maximálnu výšku
          const minHeight = 550;
          const maxHeight = 1500;

          let finalHeight = Math.max(minHeight, Math.min(calculatedHeight, maxHeight));

          pdf.style.height = finalHeight + 'px';
        });
      }
    }

    // Spustiť pri načítaní
    adjustPdfHeight();

    // Spustiť pri zmene veľkosti okna (s debounce)
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(adjustPdfHeight, 250);
    });

  });

})();

/**
 * Gallery Swiper and Lightbox
 */
import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
import GLightbox from 'glightbox';

document.addEventListener('DOMContentLoaded', function() {
  // Initialize Swiper
  const gallerySwiper = document.querySelector('.gallery-swiper');

  if (gallerySwiper) {
    new Swiper('.gallery-swiper', {
      modules: [Autoplay],

      // Slides per view - responsive
      slidesPerView: 1,
      spaceBetween: 0,

      breakpoints: {
        // Mobile landscape
        640: {
          slidesPerView: 2,
          spaceBetween: 0,
        },
        // Tablet and up - 3 slides
        1024: {
          slidesPerView: 3,
          spaceBetween: 0,
        },
      },

      // Autoplay - 2 seconds
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },

      // Loop
      loop: true,
    });

    // Initialize GLightbox
    const lightbox = GLightbox({
      selector: '.glightbox',
      touchNavigation: true,
      loop: true,
      autoplayVideos: true,
    });
  }
});
